const computeMonthlyOn = on => ({
  bymonthday: on.day,
});

export default computeMonthlyOn;



// WEBPACK FOOTER //
// ./src/lib/utils/computeRRule/toString/computeMonthlyOn.js